import { type DealFormDataWithTargeting, dealFormField } from '@openx/types/deal.ts';
import { SegmentPartnerRevenueMethod } from '@openx/types/gqlTypes.ts';
import { type AudiencePricing, MatchingOperator } from '@openx/types/targeting/audience.ts';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

type UseIntersectingAudienceCpmLockParams = {
  pricingInfo?: AudiencePricing | undefined;
  hasFees: boolean;
  loadingAudienceCheck: boolean;
};

/** Locks a deal with fees and an intersecting audience (even single-partner) to CPM; returns whether locked. */
export const useIntersectingAudienceCpmLock = ({
  pricingInfo,
  hasFees,
  loadingAudienceCheck,
}: UseIntersectingAudienceCpmLockParams): boolean => {
  const { getValues, setValue } = useFormContext<DealFormDataWithTargeting>();
  const isIntersectingAudience =
    hasFees && !loadingAudienceCheck && pricingInfo?.operator === MatchingOperator.INTERSECTION;

  useEffect(() => {
    if (
      isIntersectingAudience &&
      getValues(dealFormField.SEGMENT_PARTNER_REVENUE_METHOD) !== SegmentPartnerRevenueMethod.Cpm
    ) {
      setValue(dealFormField.SEGMENT_PARTNER_REVENUE_METHOD, SegmentPartnerRevenueMethod.Cpm);
    }
  }, [isIntersectingAudience, getValues, setValue]);

  return isIntersectingAudience;
};
